import { render, staticRenderFns } from "./ApiPlaygroundView.vue?vue&type=template&id=470f7826&scoped=true&"
import script from "./ApiPlaygroundView.vue?vue&type=script&lang=js&"
export * from "./ApiPlaygroundView.vue?vue&type=script&lang=js&"
import style0 from "./ApiPlaygroundView.vue?vue&type=style&index=0&id=470f7826&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470f7826",
  null
  
)

export default component.exports